import { useState, useEffect, useContext } from "react";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import PropertiesListing from "../../../../components/PropertiesListing";
import * as SC from "./PropertyData.Styled";
import { DEF_COORDS } from "../../../../constants/Statics";
import { postApi_home } from "../../../../utils/apis";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/actions";
import { ButtonIconBack, Col, Flex, Row } from "../../../../components/Common.Styled";
import * as SLSC from "../../../MenzillPrivatePages/SideLayout.Styled";
import { formatPrice, joinStrs } from "../../../../utils/functions";
import { FacebookIcon, TwitterIcon, EmailIcon } from "react-share";
import { FacebookShareButton, TwitterShareButton, EmailShareButton } from "react-share";
import { DropdownMenu, DropdownItem, DropdownToggle, Dropdown, UncontrolledDropdown } from "reactstrap";
import * as RiIcons from "react-icons/ri";
import { LanguageContext } from "../../../../utils/language/Language";
import shareImg from "../../../../images/shareImg.png";
import filterImg from "../../../../images/filterIcon.png";

const HomeData = (props) => {
  const [currentPos, setCurrentPos] = useState(DEF_COORDS);
  const [propertyType, setPropertyType] = useState("A");
  const [properties, setProperties] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [shareBtn, setShareBtn] = useState(false);
  const [shareData, setShareData] = useState([]);
  const [shareUrl, setShareUrl] = useState("");
  const [page, setPage] = useState(0);
  const inpVals = {};

  useEffect(() => {
    getCurrentPos();
  }, []);

  useEffect(() => {
    currentPos && propertyType && loadProperties({ currentPos, propertyType });
  }, [currentPos, propertyType, props.userData]);

  const getCurrentPos = () => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setCurrentPos({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
    });
  };

  const loadProperties = async ({ currentPos, propertyType, page = 0 }) => {
    try {
      // console.log("postApi_home", postApi_home);
      const resData = await postApi_home({ coords: currentPos, propertyType, page });
      setProperties(get(resData, "data.property.data", []));
      setTotalPages(+get(resData, "data.property.metadata.total_pages", 0));
      setPage(+get(resData, "data.property.metadata.page", 1));
    } catch (err) {
      console.log(err);
      toast.error("Cannot load properties");
    }
  };

  const loadShareData = (data) => {
    let urlToSend = "";
    data.map((item) => {
      urlToSend = urlToSend + `${window.location.href}property/${item} `;
    });
    setShareData(urlToSend);
  };

  const { dictionary } = useContext(LanguageContext);

  // console.log(totalPages);
  return (
    <SC.HomeDataCont>
      <SC.PropertyHeadWrap>
        <SC.ExploreText>{dictionary.menzilString.EXPLORE_THE_GOOD_PLACES}</SC.ExploreText>
        <SC.ExploreDesc>{dictionary.menzilString.browse_and_save}</SC.ExploreDesc>
      </SC.PropertyHeadWrap>

      <SC.Body>
        <PropertiesListing
          shareBtn={shareBtn}
          properties={properties}
          loadShareData={loadShareData}
          homeList={true}
          onSaveUnsave={() => loadProperties({ currentPos, propertyType })}
        />
      </SC.Body>
      {console.log(dictionary.menzilString.View_All_Properties)}
 
      <SC.PropertyViewBtn>
        <SC.ViewBtn
          onClick={() => {
            props.history.push(`/search-property?lat=${currentPos.lat}&long=${currentPos.lng}&sale_type=1&property_type=`);
          }}
        >
          {dictionary.menzilString.View_All_Properties}
        </SC.ViewBtn>
      </SC.PropertyViewBtn>
    </SC.HomeDataCont>
  );
};

// export default withRouter(HomeData);

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HomeData));
